/**
 * Orders module path consts — the one map for nav and web links.
 * Param builders are the only place that concatenates ids into paths.
 */
export const ORDERS_ROUTES = {
   LIST: '/orders',
   DETAIL: '/orders/$orderId',
   CALENDAR: '/calendar'
} as const;

export const orderDetailPath = (orderId: string) => `${ORDERS_ROUTES.LIST}/${orderId}` as const;
